module.exports = __webpack_public_path__ + "static/media/clippers-logo.51a5b403.svg";